export default {};

// for some reason this isn't taken into account.
// i am using MDXProvider in the layout file instead.

//   pre: props => props.children,
//   code: props => {
//     return (
//     <Prism {...props} />
//   );}
// };
